/**
 * JumpLink
 * @class
 * @classdesc JumpLink
 */
export class jumpLink {
    constructor(selector) {
        this.jumpLinks = document.querySelectorAll('.js-jump-link');
        this.jumpLinks.forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const params = JSON.parse(el.getAttribute('data-params'));
                const url = el.getAttribute('href');
                const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
                // _blankで移動する
                if (el.getAttribute('target') === '_blank') {
                    window.open(`${url}?${queryString}`);
                } else {
                    window.location.href = `${url}?${queryString}`;
                }
            });
        });
    }
}